import { API } from '../config';
const ENDPOINT = `${API}/api/client-error`;

const seen = new Map();

function normalizeError(error) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  if (typeof error === 'string') {
    return { name: 'Error', message: error };
  }

  try {
    return { name: 'Error', message: JSON.stringify(error) };
  } catch {
    return { name: 'Error', message: String(error) };
  }
}

function shouldSkip(payload) {
  const key = `${payload.type}:${payload.name}:${payload.message}:${payload.pageUrl}`;
  const now = Date.now();
  const last = seen.get(key) || 0;
  seen.set(key, now);
  return now - last < 5000;
}

export function logClientError(error, context = {}) {
  const normalized = normalizeError(error);
  const payload = {
    level: context.level || 'error',
    type: context.type || 'frontend-error',
    ...normalized,
    componentStack: context.componentStack,
    pageUrl: window.location.href,
    context: context.details,
  };

  if (shouldSkip(payload)) return;

  const body = JSON.stringify(payload);

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    if (navigator.sendBeacon(ENDPOINT, blob)) return;
  }

  fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
}

export function installGlobalErrorLogging() {
  window.addEventListener('error', (event) => {
    logClientError(event.error || event.message, {
      type: 'window-error',
      details: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    logClientError(event.reason || 'Unhandled promise rejection', {
      type: 'unhandledrejection',
    });
  });
}
